<template>
    <div style="width: 100%;">
        <div
            v-if="tagType == 'div'"
            class="embed-responsive embed-responsive-16by9"
            v-html="innerHTML"
        ></div>
        <a 
            v-else-if="tagType == 'a'"
            :href="href"
            target="_blank"
            v-text="innerText"
        ></a>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: '',
        },
    },
    data: function() {
        return {
            tagType: '',
            innerHTML: '',
            innerText: '',
            href: ''
        };
    },
    methods: {
        async parse() {
            let response;
            try {
                response = await axios.post('api/embed/oembed', {
                    url: this.url
                });
            }
            catch( error ) {
                console.warn( error );
            }

            if( response && response.data.code )
            {
                this.tagType = 'div';
                this.innerHTML = response.data.code.trim();
            }
            else if( response && response.data.title && response.data.url )
            {
                this.tagType = 'a';
                this.innerText = response.data.title.trim();
                this.href = response.data.url;
            }
        },
    },
    mounted: function() {
        this.parse();
    },
}
</script>